"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProgressTracker = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ProgressTracker = ({
  steps,
  activeStep,
  ...rest
}) => {
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "step-progress-bar"
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: `side-bar ${activeStep > 0 ? "side-bar--completed" : ""}`
  }), steps.map((step, i) => {
    i = i + 1;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "progress-block"
    }, i < activeStep ? /*#__PURE__*/_react.default.createElement("div", {
      className: `bullet bullet--done
                }`
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "check-icon ri-check-line"
    })) : /*#__PURE__*/_react.default.createElement("div", {
      className: `bullet ${activeStep === i ? "bullet--active" : ""}`
    }, i), /*#__PURE__*/_react.default.createElement("p", {
      className: "label"
    }, step)), i === steps.length ? /*#__PURE__*/_react.default.createElement("span", {
      className: `side-bar ${activeStep > i ? "side-bar--completed" : ""}`
    }) : /*#__PURE__*/_react.default.createElement("span", {
      className: `bar ${activeStep > i ? "bar--completed" : ""}`
    }));
  }));
};

exports.ProgressTracker = ProgressTracker;
ProgressTracker.defaultProps = {
  activeStep: 1,
  steps: ["Step 1", "Step 2", "Step 3"]
};
ProgressTracker.propTypes = {
  steps: _propTypes.default.array,
  activeStep: _propTypes.default.number
};
var _default = ProgressTracker;
exports.default = _default;